import React, { Component } from 'react'
import { object, string } from 'prop-types'
import styles from './HorizontalBarChart.styl'

export default class HorizontalBarChart extends Component {

	static propTypes = {
		value: object,
		title: string
	}
	state = { width: 0 }

	componentDidMount() {
		const { value: { current, athlete } } = this.props
		setTimeout(() => {
			let width = Math.round(athlete / current * 100)
			if (isNaN(width)) { width = 0 }
			if (width > 100) { width = 100 }
			this.setState({ width })
		}, 10)
	}
	componentWillReceiveProps(nextProps) {
		const { value: { current, athlete } } = nextProps
		let width = Math.round(athlete / current * 100)
		if (isNaN(width)) { width = 0 }
		if (width > 100) { width = 100 }
		this.setState({ width })
	}

	render() {
		const { title, value: { current, athlete } } = this.props
		const { width } = this.state

		return (
			<div className={ styles['container'] }>
				<h2>{ title }</h2>
				<div className={ styles['info-display-container'] }>
					<div>
						<strong>Valor prescrito</strong>
						<span>{ Math.round(current) }</span>
					</div>
					<div>
						<strong>Valor acumulado</strong>
						<span>{ Math.round(athlete) }</span>
					</div>
				</div>
				<div className={ styles['bars-container'] }>
					<div className={ styles['grey-bar'] } />
					<div className={ styles['orange-bar'] } style={ { width: `${ width }%` } }>
						<div className={ styles['percentage'] } style={ width === 0 ? { right: '-25px' } : {} }>
							{ `${ width }%` }
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/HorizontalBarChart/HorizontalBarChart.js